@use '../../global/icons';

:host {
  display: inline-flex;
}
